// tslint:disable-next-line:interface-over-type-literal
type Environment = {
  baseURL: string;
  daccaBaseURL: string;
  appInsightsInstrumentationKey: string;
  networkHealthTimeout: number;
  maxImageHeight: number;
  maxImageWidth: number;
  imageQuality: number;
  oktaAuthorizeUrl: string;
  oktaClientId: string;
  useOkta: boolean;
  oktaLogoutUrl: string;
};

let environment: Environment = {
  baseURL: '',
  daccaBaseURL: '',
  appInsightsInstrumentationKey: '',
  networkHealthTimeout: 5000,
  maxImageHeight: 600,
  maxImageWidth: 1080,
  imageQuality: 50,
  oktaAuthorizeUrl: 'https://belfius.okta.com/oauth2/aus7fs4k2plZXAGtC417/v1/authorize',
  oktaClientId: '0oa4tjr7dXZ23GYrm416',
  useOkta: false,
  oktaLogoutUrl: 'https://belfius.okta.com/login/signout'
};

function initializeEnvironment(env: NodeJS.ProcessEnv): Environment {
  let currentEnvironment = env.REACT_APP_ENV || "development"; 

  switch (currentEnvironment) {
    case 'local':
      environment = require('./environment.local').environment;
      break;
    case 'development':
      environment = require('./environment.development').environment;
      break;
    case 'production':
      environment = require('./environment.production').environment;
      break;
    case 'production-okta':
      environment = require('./environment.production-okta').environment;
      break;
    case 'development-okta':
      environment = require('./environment.development-okta').environment;
      break;
  }

  return environment;
}

export { Environment, initializeEnvironment, environment };
